import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import { ConnectionsSlice } from '../types/connections';
import connections from './asyncReducers/connections';

const connectionsExtraReducers = (builder: ActionReducerMapBuilder<ConnectionsSlice>) => {
    connections(builder);
};

export default connectionsExtraReducers;
